<template>
  <div 
    class="moow-master-container play-background"
    v-loading.fullscreen="loading" element-loading-text="Saving Data ..." element-loading-spinner="el-icon-loading">
    <nav-basic :progress="90" title=""></nav-basic>
    <div class="container">
      <b-row class="step-header"><p class="moow-header">House Rules</p></b-row>
      <b-row>
        <b-col md="6" class="pt-2 form-container amenities-form">
          <md-card class="island-card pr-3">
            <md-card-content>
              <b-row>
                <b-col class="text-right pr-0" text-align="right">
                  <b-form-group id="fieldsetHorizontal" horizontal breakpoint="lg" label="Parties & events allowed" :label-cols="6" label-for="inputHorizontal"
                    align="left">
                      <toggle-button v-model="eventsAllowed" :height="35" :width="70" color="#1f8efa"  style="float:right"  />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="text-right pr-0" text-align="right">
                  <b-form-group id="fieldsetHorizontal" horizontal breakpoint="lg" label="Suitable for kids" :label-cols="6" label-for="inputHorizontal"
                    align="left">
                      <toggle-button v-model="suitableForKids" :height="35" :width="70" color="#1f8efa"  style="float:right"  />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="text-right pr-0" text-align="right">
                  <b-form-group id="fieldsetHorizontal" horizontal breakpoint="lg" label="Pets allowed" :label-cols="6" label-for="inputHorizontal"
                    align="left">
                      <toggle-button v-model="petsAllowed" :height="35" :width="70" color="#1f8efa"  style="float:right"  />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="text-right pr-0" text-align="right">
                  <b-form-group id="fieldsetHorizontal" horizontal breakpoint="lg" label="Smoking allowed" :label-cols="6" label-for="inputHorizontal"
                    align="left">
                      <toggle-button v-model="smokingAllowed" :height="35" :width="70" color="#1f8efa"  style="float:right"  />
                  </b-form-group>
                </b-col>
              </b-row>
            </md-card-content>
          </md-card>

          <b-row class="step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <md-button @click="prev()" class="md-primary">
                <md-icon>arrow_back</md-icon>Back
              </md-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <md-button @click="next" class="md-primary play-cta-button makeup">Next</md-button>
            </b-col>
          </b-row>


        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  // import {
  //   suitableList
  // } from '../lists.js'
  const lists = require("@/lists.js");

  import {
    updateListingParts
  } from '../listingFunctions.js'
  export default {
    name: 'price2',
    data() {
      return {
        loading: false,
        suitable: lists.suitableList,
        eventsAllowed: false,
        suitableForKids: false,
        petsAllowed: false,
        smokingAllowed: false
      }
    },
    created() {
      this.setAllowedSwitchesFromStore()
    },
    computed: {
      techDet() {
        this.updateRulesList()
        return this.$store.getters.techDet
      }
    },
    methods: {
      setAllowedSwitchesFromStore(){
        if(this.$store.getters.techDet.suitable.indexOf('events') != -1) this.eventsAllowed = true
        if(this.$store.getters.techDet.suitable.indexOf('pets') != -1) this.petsAllowed = true
        if(this.$store.getters.techDet.suitable.indexOf('familyFND') != -1) this.suitableForKids = true
        if(this.$store.getters.techDet.suitable.indexOf('smoking') != -1) this.smokingAllowed = true
      },
      updateRulesList() {
        let eventIndex = this.$store.getters.techDet.suitable.indexOf('events')
        let petsIndex = this.$store.getters.techDet.suitable.indexOf('pets')
        let kidsIndex = this.$store.getters.techDet.suitable.indexOf('familyFND')
        let smokingIndex = this.$store.getters.techDet.suitable.indexOf('smoking')

        if(this.eventsAllowed && eventIndex == -1) {
          this.$store.getters.techDet.suitable.push('events')
        }
        else if(!this.eventsAllowed && eventIndex != -1){
          this.$store.getters.techDet.suitable.splice(eventIndex,1)
        }

        if(this.petsAllowed && petsIndex == -1) {
          this.$store.getters.techDet.suitable.push('pets')
        }
        else if(!this.petsAllowed && petsIndex != -1){
          this.$store.getters.techDet.suitable.splice(petsIndex,1)
        }

        if(this.suitableForKids && kidsIndex == -1) {
          this.$store.getters.techDet.suitable.push('familyFND')
        }
        else if(!this.suitableForKids && kidsIndex != -1){
          this.$store.getters.techDet.suitable.splice(kidsIndex,1)
        }

        if(this.smokingAllowed && smokingIndex == -1) {
          this.$store.getters.techDet.suitable.push('smoking')
        }
        else if(!this.smokingAllowed && smokingIndex != -1){
          this.$store.getters.techDet.suitable.splice(smokingIndex,1)
        }
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      next() {
        this.save()
        this.leavePage('PRICE2', 'price4')
      },
      prev() {
        this.saveLocally()
        this.leavePage('PRICE2', 'price1')
      },
      saveAndExit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
            this.leavePage('PRICE2', 'dashboard')
          } else {
            this.notifyError('Notification', 'Something is missing')
          }
        })
      },
      save(){
        sessionStorage.setItem('sceneStatus', 0)
        sessionStorage.setItem('basicStatus', 1)
        this.saveLocally()
        updateListingParts(this.createUpdateParts()).catch(err => {})
      },
      createUpdateParts(){
        return{
          'techDet': this.techDet
        }
      },
      saveLocally(){
        this.$store.commit('UPDATE_TECHDET', this.techDet)
        this.updateRulesList()
      }
    },
    props: {
      data: {
        type: Object,
        required: false
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/styles/global.css';
  @import '../assets/styles/add-steps.css';
  #desc {
    background-color: rgb(240, 229, 229);
  }

  .checkBtn {
    opacity: 0;
    outline: none;
    position: absolute;
    margin: 0;
    left: -999px;
  }

  .button {
    margin: 10px;
    width: 150px;
    height: 40px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #1f8efa;
    border-radius: 4px;
    border: solid 1px #1f8efa;
    background-color: #ffffff
  }

  p {
    color: #757575;
    text-align: left;
    font-size: 14px;
  }


  .row {
    border-bottom: 1px solid #ededed;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .form-group {
    margin-bottom: 0px;
  }

  label {
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/price2.vue